import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@zapier/zinnia-icons";
import { useDetails } from "../../../utils/useDetails.js";
import { Submenu } from "../Submenu/Submenu.js";
import styles from "./Dropdown.module.scss.js";
import { useHeaderContext } from "../Header.js";
function Dropdown(props) {
  const context = useHeaderContext();
  const { ref, isOpen, handleSummaryClick } = useDetails({
    onOpen: () => {
      context.emitUserInteractionEvent({
        event_action: "open",
        interaction_name: "header_dropdown_open",
        interaction_raw_text: props.label
      });
    },
    onClose: () => {
      context.emitUserInteractionEvent({
        event_action: "close",
        interaction_name: "header_dropdown_close",
        interaction_raw_text: props.label
      });
    }
  });
  return /* @__PURE__ */ jsxs("details", { ref, open: isOpen, "data-testid": "nav-dropdown", children: [
    /* @__PURE__ */ jsxs(
      "summary",
      {
        className: styles.summary,
        "data-testid": "nav-dropdown-summary",
        onClick: handleSummaryClick,
        children: [
          /* @__PURE__ */ jsx("span", { children: props.label }),
          /* @__PURE__ */ jsx("span", { className: styles.indicator, children: /* @__PURE__ */ jsx(Icon, { name: "arrowSmallDown", size: 16 }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Submenu, { ...props.submenu, label: props.label })
  ] });
}
export {
  Dropdown
};
